import { useEffect, useState } from 'react';

/**
 * Returns the id of the section currently sitting just below the fixed header.
 * `offset` is the header height in px; the detection band runs from there to ~22% of the viewport.
 */
const useScrollSpy = (sections: string[], offset = 0) => {
  const [activeSection, setActiveSection] = useState('');

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActiveSection(entry.target.id);
          }
        });
      },
      { rootMargin: `-${offset}px 0px -78% 0px` }
    );

    sections.forEach((sectionId) => {
      const section = document.getElementById(sectionId);
      if (section) observer.observe(section);
    });

    return () => observer.disconnect();
  }, [sections, offset]);

  return activeSection;
};

export default useScrollSpy;
